import { AppState } from '../../reducers';

export function selectProductLayout(state: AppState) {
  const { userSelectedLayout } = state.areas.productCollection;

  return userSelectedLayout;
}
